/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Google_Not_LinkedInputs */

const cs_auth_google_not_linked = /** @type {(inputs: Auth_Google_Not_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`K tomuto Google účtu není propojený žádný účet. Nejdřív se přihlaste e-mailem a propojte Google v profilu.`)
};

const en_auth_google_not_linked = /** @type {(inputs: Auth_Google_Not_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account is linked to this Google account. Sign in with email and connect Google in profile settings first.`)
};

/**
* | output |
* | --- |
* | "No account is linked to this Google account. Sign in with email and connect Google in profile settings first." |
*
* @param {Auth_Google_Not_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_google_not_linked = /** @type {((inputs?: Auth_Google_Not_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Google_Not_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_google_not_linked(inputs)
	return cs_auth_google_not_linked(inputs)
});